import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';
import { Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0F1C] border-t border-[#2563EB]/20 py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* AxioSera Branding */}
        <div className="text-center mb-12 pb-8 border-b border-[#2563EB]/20">
          <a
            href="https://axiosera.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <img src="/axiosera-logo.png" alt="AxioSera" className="h-20 w-auto mx-auto mb-3 hover:opacity-80 transition-opacity" />
          </a>
          <p className="text-[#2563EB] text-sm font-semibold">An AxioSera Product</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src="/logo.png" alt="PriceStrike - Name Your Price" className="h-96 w-auto mb-4" />
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              Composable infrastructure. AI as a feature. Built for SMB pricing transformation.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              {mockData.footerLinks.product.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Free Tools Links */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Free Tools</h4>
            <ul className="space-y-2">
              {mockData.footerLinks.freeTools.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-[#2563EB] hover:text-[#3B82F6] transition-colors duration-200 font-medium"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries Links */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Industries</h4>
            <ul className="space-y-2">
              {mockData.footerLinks.industries.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              {mockData.footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://axiosera.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200"
                >
                  AxioSera Platform
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#2563EB]/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
            <p className="text-[#94A3B8] text-sm">
              © 2025 PriceStrike. All rights reserved.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-6">
              <a
                href="https://linkedin.com/company/pricestrike"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
            
            <a
              href="mailto:hello@axiosera.com"
              className="text-[#2563EB] hover:text-[#3B82F6] transition-colors duration-200"
              aria-label="Send email to hello@axiosera.com"
            >
              hello@axiosera.com
            </a>
          </div>
          
          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-6 pt-4 border-t border-[#2563EB]/10">
            <Link to="/privacy-policy" className="text-sm text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="text-sm text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200">
              Terms of Use
            </Link>
            <Link to="/cookie-policy" className="text-sm text-[#94A3B8] hover:text-[#2563EB] transition-colors duration-200">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;